import {
  makeStyles,
} from "@material-ui/core";
import _ from "lodash";
import * as React from "react";
import {  useState } from "react";

import { CustomTheme } from "../../../../types/customTheme";
import LoginPage from "./LoginPage";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";

const useStyles = makeStyles((theme: CustomTheme) => ({
 
}));

export interface ManageAppsProps {}

/* Get all location information using API call at initial load. */
const SignInPage: React.FunctionComponent<ManageAppsProps> = () => {
  const [error, setError] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const classes = useStyles();

  return (
    <>
        <LoginPage
          setAuthError={setError}
        />

      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />

      <DefaultAlert
        open={!!alertMessage}
        handleClose={() => setAlertMessage("")}
        message={alertMessage}
        severity="success"
      />
    </>
  );
};

export default SignInPage;
